import { lazy, Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { Notice } from "@/components/ui/notice";
import { Spinner } from "@/components/ui/panel";
import { errorMessage } from "@/lib/api";
import { useMe } from "@/lib/session";

const LandingPage = lazy(() => import("@/pages/public/landing").then((m) => ({ default: m.LandingPage })));

/** Signed in, 2FA set up and no temporary password left — otherwise send the user to the right screen. */
export function RequireAuth() {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <Spinner />;
  if (me.isError) return <div className="p-6"><Notice tone="bad" title="読み込みに失敗しました">{errorMessage(me.error)}</Notice></div>;
  // The front door shows what the service is; everything else asks for sign-in.
  if (!me.data && location.pathname === "/") return <Suspense fallback={<Spinner />}><LandingPage /></Suspense>;
  if (!me.data) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (!me.data.user.twoFactorEnabled) return <Navigate to="/setup-2fa" replace />;
  if (me.data.user.mustChangePassword) return <Navigate to="/change-password" replace />;
  return <Outlet />;
}
